import { ICategory, TServiceMap } from '@features/categories/typescript';
export const createServiceMap = (category: ICategory | ICategory[]): TServiceMap => {
  if (Array.isArray(category)) {
    return category.reduce((acc, curr) => ({
      ...acc,
      ...createServiceMap(curr)
    }), {});
  }
  const serviceMapObject = {
    [category.id]: category.pageSlug
  };
  const children: ICategory[] = category.children && !Array.isArray(category.children) ? Object.values(category.children) : [];
  if (children) {
    children.forEach(child => {
      Object.assign(serviceMapObject, createServiceMap(child));
    });
  }
  return serviceMapObject;
};

// TODO: to optimize
export const searchCategoryTree = (category: ICategory | ICategory[], targetId: number): ICategory | null => {
  let categoryToReturn: ICategory | null = null;
  if (Array.isArray(category)) {
    category.forEach(cat => {
      const result = searchCategoryTree(cat, targetId);
      if (result) {
        categoryToReturn = result;
      }
    });
    return categoryToReturn;
  }
  if (category.id === targetId) {
    categoryToReturn = category;
  }
  const children: ICategory[] = category.children && !Array.isArray(category.children) ? Object.values(category.children) : [];
  if (children) {
    children.forEach(child => {
      const result = searchCategoryTree(child, targetId);
      if (result) {
        categoryToReturn = result;
      }
    });
  }
  return categoryToReturn;
};